module.exports = __webpack_public_path__ + "32b92e530348d41e9bb716d4e34c62d1.png";